import React, { useEffect, JSX } from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import Icon from '@components/atoms/icon/icon';
import Button from '@components/atoms/button/button';
import { scrollToTop } from '@helpers/utils/general';
import { IFlattenedSellerInformation, SellerInfoFormPayload } from '@interfaces/models/seller-info/seller-information';
import { UserFlags } from '@context/seller-information.context';
import styles from './seller-information-success.module.scss';

type SellerInformationSuccessProps = {
  taxInformation?: IFlattenedSellerInformation;
  payload?: SellerInfoFormPayload;
  onEditInformation: () => void;
  userFlags?: UserFlags;
  showSuccess?: boolean;
  isEdited?: boolean;
};

const SellerInformationSuccess: React.FC<SellerInformationSuccessProps> = (props): JSX.Element => {
  const { t } = useTranslation('get-paid');
  const { payload, taxInformation, onEditInformation, userFlags, showSuccess } = props;

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div className={styles.sellerInformationSuccess}>
      <div className={styles.sellerInformationSuccess__icon}>
        <Icon
          name="success-default"
          ariaHidden
        />
      </div>
      <div className={clsx(styles.sellerInformationSuccess__title, 'vc-text-bold', 'vc-text-H20')}>
        {t('GET_PAID.TAX_INFORMATION_FORM.SUBMIT_SUCCED', 'Thank you!')}
      </div>
      <div className={clsx(styles.sellerInformationSuccess__subtitle, 'vc-text-H16')}>
        {userFlags.isEUB2CUser && taxInformation?.tin && taxInformation?.vatNumber && !showSuccess
          ? t('GET_PAID.TAX_INFORMATION_FORM.ERROR.SUBMIT_DUPLICATED', 'You have already submitted your information.')
          : taxInformation?.tin && !showSuccess
            ? t('GET_PAID.TAX_INFORMATION_FORM.ERROR.SUBMIT_DUPLICATED', 'You have already submitted your information.')
            : t('GET_PAID.TAX_INFORMATION_FORM.SUCESS.DESCRIPTION', 'Your information has been submitted.')}
      </div>
      {(payload?.tin ?? taxInformation?.tin) && (
        <div className={clsx(styles.sellerInformationSuccess__content, 'vc-text-H16')}>
          <p>{`${t('GET_PAID.TAX_INFORMATION_FORM.TAX_NAME.GENERIC', 'Tax Identification Number')}:`}</p>
          <p>{payload?.tin ?? taxInformation?.tin}</p>
        </div>
      )}
      {(payload?.vatNumber ?? taxInformation?.vatNumber) && (
        <div className={clsx(styles.sellerInformationSuccess__content, 'vc-text-H16')}>
          <p>{`${t('GET_PAID.TAX_INFORMATION_FORM.VAT_FIELD', 'VAT Number')}:`}</p>
          <p>{payload?.vatNumber ?? taxInformation?.vatNumber}</p>
        </div>
      )}
      <Button
        className={clsx(styles.sellerInformationSuccess__cta, 'vc-text-l')}
        variant="primary"
        size="large"
        onClick={onEditInformation}
      >
        {t('GET_PAID.TAX_INFORMATION_FORM.EDIT_CTA', 'Edit my information')}
      </Button>
    </div>
  );
};

export default SellerInformationSuccess;
